import * as React from 'react'

const getServerSnapshot = () => false

export function useIubendaDialogOpen(enabled: boolean) {
  const subscribe = React.useCallback(
    (onChange: () => void) => {
      if (!enabled) {
        return () => {}
      }

      const observer = new MutationObserver(onChange)
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden'],
      })
      return () => observer.disconnect()
    },
    [enabled],
  )

  const getSnapshot = React.useCallback(() => {
    if (!enabled) {
      return false
    }

    const panel = document.querySelector<HTMLElement>('#iubenda-iframe')
    if (!panel || panel.hidden) {
      return false
    }

    const style = getComputedStyle(panel)
    return style.display !== 'none' && style.visibility !== 'hidden'
  }, [enabled])

  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
